import * as React from 'react';
import { Container, Row } from 'reactstrap';
import MenuTile from '../core/MenuTile';
import { faScaleUnbalancedFlip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScaleUnbalanced } from '@fortawesome/free-solid-svg-icons';



const CourtReportingOptions = () => {
    return (
        <Container fluid>
            <Row style={{
                paddingTop: '2em',
                display: "flex",
                alignContent: "flex-start",
                columnGap: "2em"
            }}>
                <MenuTile tileLink="/939CourtReporting"
                    tileTitle="939.185 Court Reporting"
                    tileDescription="Used to upload and review 939.185 Court Reports"
                    icon={<FontAwesomeIcon className="menuIcon" icon={faScaleUnbalancedFlip} />}
                    tileType="fontawesome" />

                <MenuTile tileLink="/29CourtReporting"
                    tileTitle="29.0085 Court Reporting"
                    tileDescription="Used to upload and review 29.0085 Court Reports"
                    icon={<FontAwesomeIcon className="menuIcon" icon={faScaleUnbalanced} />}
                    tileType="fontawesome" />

                <MenuTile tileLink="/CreateCourtReports939"
                    tileTitle="Create Court Report 939.185 Records"
                    tileDescription="Create Court Reports 939.185 Records for a new reporting Fiscal Year and/or Quarter" icon="bi bi-file-earmark-plus-fill" />

                <MenuTile tileLink="/CreateCourtReports29"
                    tileTitle="Create Court Report 29.0085 Records"
                    tileDescription="Create Court Reports 29.0085 Records for a new reporting Fiscal Year" icon="bi bi-file-earmark-plus-fill" />

                <MenuTile tileLink="/AFRAssignment939"
                    tileTitle="Court Reporting 939.185 Assignment"
                    tileDescription="Used to track the assignment and reconciliation of the Court Reports 939.185" icon="bi bi-arrow-left-right" />

                <MenuTile tileLink="/CR29Assignments"
                    tileTitle="Court Reporting 29.0085 Assignment"
                    tileDescription="Used to track the assignment and reconciliation of the Court Reports 29.0085" icon="bi bi-arrow-left-right" />

                <MenuTile tileLink="/AccountCodeManagementCR"
                    tileTitle="Account Codes"
                    tileDescription="Create, edit, or deprecate account codes" icon="bi bi-file-medical" />
            </Row>
        </Container>
    );
}

export default CourtReportingOptions;